module.exports = __webpack_public_path__ + "static/media/shadow.7148acdf.png";